import './i18n/i18n';
import 'common-components/style.css';
import '@definitions/styles/global.css';
import { StyleConfigProvider, antdLocales } from 'common-components';
import { useTranslation } from 'react-i18next';
import { AuthConsumer, AuthProvider } from '@components';
import { AppRouter } from '@navigation/app-router';

function App() {
  const { i18n } = useTranslation();
  return (
    <StyleConfigProvider locale={antdLocales[i18n.language] ?? antdLocales.fr}>
      <div className="App">
        <AuthProvider>
          <AuthConsumer>
            <AppRouter />
          </AuthConsumer>
        </AuthProvider>
      </div>
    </StyleConfigProvider>
  );
}

export default App;
